import { styled, Box, Typography, Grid } from '@mui/material';
import StarsIcon from '@mui/icons-material/Stars';

export const BoxContainer = styled(Grid)<{ isHighlighted: boolean }>(
  ({ theme, isHighlighted }) => ({
    position: 'relative',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    backgroundColor: '#1E1E1E',
    border: isHighlighted ? undefined : '2px solid #8895FA',
    paddingBottom: isHighlighted ? undefined : theme.spacing(6),
    borderRadius: theme.spacing(1),
    maxWidth: 400,
    width: '100%',
    [theme.breakpoints.up('desktop')]: {
      marginTop: isHighlighted ? theme.spacing(4) : undefined,
    },
    [theme.breakpoints.down('desktop')]: {
      paddingBottom: 0,
    },
  })
);

export const StyledMostPopularLabelContainer = styled(Box)(({ theme }) => ({
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  justifySelf: 'flex-end',
  marginBottom: theme.spacing(1),
  gap: theme.spacing(0.5),
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(0.5, 1),
  background: theme.palette.secondary.main,
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
}));

export const StyledMostPopularText = styled(Typography)(() => ({
  fontSize: 12,
  fontWeight: 700,
}));

export const StyledStarsIcon = styled(StarsIcon)({});
StyledStarsIcon.defaultProps = {
  fontSize: 'inherit',
};
